import styled from "styled-components";
export const AppWrapper = styled.div`
  //max-width: calc(768px + 16px * 2);
  margin: 0 auto;
  display: flex;
  min-height: 100%;
  padding: 0 0px;
  flex-direction: column;
`;

export const AppWorkspace = styled.div`
  margin: 0 0 0 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
